import { IMealsValidation } from '../types/meals';
import { defaultTTranslate, MEASURE } from 'src/constants/main';
import { IMeal, IMealItem } from 'src/types/combo';
import { DELIVERY_ORDER_TYPE, IProductV4Size, PRODUCT_TYPE } from 'src/types/product';

export enum MealItemEditAction {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete',
}

export const defaultMealValidation: IMealsValidation = {
  valid: true,
  images: true,
  name: {
    enValid: true,
    arValid: true,
  },
  category: true,
  sizesLength: true,
  groupsLength: true,
  groups: [],
};

export const defaultMealSize: IProductV4Size = {
  id: 0,
  name: defaultTTranslate,
  calories: null,
  price: '0',
  weight: '',
  unit: MEASURE.NULL,
};

export const defaultMealItem: IMealItem = {
  id: 0,
  name: defaultTTranslate,
  price: '0',
  product_price: '0',
  image: '',
  unit: MEASURE.NULL,
  weight: '',
  order_type: DELIVERY_ORDER_TYPE.ALL,
  size_id: 0,
  group_id: 0,
  choice_id: 0,
};

export const defaultMeal: IMeal = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  order_type: DELIVERY_ORDER_TYPE.ALL,
  description: undefined,
  price: '0',
  calories: null,
  weight: '',
  unit: MEASURE.NULL,
  //
  type: PRODUCT_TYPE.MEAL_COMBO,
  //
  image: '',
  images: undefined,
  //
  min_quantity: 1,
  is_donation: 0,
  is_favorite: 0,
  sort: 0,
  earn: undefined,
  redeem: undefined,
  //
  is_modifiers: 0,
  modifiers: [],
  //
  is_size: 1,
  size: null,
  sizes: [],
  //
  groups: [],
  choices: [],
  items: [],
  //
  is_exclusions: 0,
  exclusions: [],
  //
  category: undefined,
  upsales_items: [],
  //
  out_of_stock: 0,
  status: 1,
  is_delete: 0,
  //
  is_draft: true,
  promocode_applicable: 0,
  cashback_applicable: 0,
  allergens: [],
  nutrients: null,
  nutrient: null,
};
